import * as React from 'react';

import * as style from './PageLayout.css';

export interface IPageLayoutProps {
  children: React.ReactElement<any>[];
}

export const PageLayout: React.FC<IPageLayoutProps> = props => {
  const { children } = props;

  return (
    <div data-testid="PageLayout" className={style['container']}>
      {children}
    </div>
  );
};
